module.exports = __webpack_public_path__ + "img/roundup_grey_desktop.007849f4.svg";